module.exports = __webpack_public_path__ + "static/img/advantagebg3-new.35a901d0.jpg";